import React from "react";
import { DownloadModel } from "../Download/DownloadModel";
import Utils from "../../core/Utils/Utils";
import { renderRichText } from "@storyblok/react";

import "./ReleaseNotesPopup.css";

const ReleaseNotesPopup: React.FC<{
  blok: DownloadModel;
  onButtonClick: (show: boolean) => void;
}> = ({ blok, onButtonClick }) => {
  const handleClick = (show: boolean) => {
    if (onButtonClick) {
      onButtonClick(show);
    }
  };
  const bodyHTML = renderRichText(blok.releaseNotes) || "";

  return (
    <div
      className="release-notes-popup-container"
      onClick={() => handleClick(false)}
    >
      <div
        className="release-notes-popup-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header">
          <h5>{blok.downloadName} RELEASE NOTES</h5>
          <button
            className="release-notes-popup-close-button"
            onClick={() => handleClick(false)}
          ></button>
        </div>
        <div className="release-notes-video-wrapper">
          <div className="release-notes-popup-released">
            Released {Utils.getDownloadFormattedDate(blok.releaseDate)}
          </div>
          <div className="release-notes-popup-released">{blok.versionId}</div>
          <div
            className="release-notes-popup-release-Notes"
            dangerouslySetInnerHTML={{ __html: bodyHTML }}
          ></div>
          {/* <div className="release-notes-popup-release-Notes">
            {blok.releaseNotes}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotesPopup;
